import PropTypes from "prop-types";
import { Box, Grid, Paper, Typography } from "@mui/material";
import BikeColor from "./BikeColor";
export default function IngresoReview({ formData, gancho }) {
  const fields = [
    ["Usuario", `${formData.nombre || ""} ${formData.apellido || ""}`.trim()],
    ["Documento", formData.cedula],
    ["Celular", formData.celular],
    ["Serie de la bicicleta", formData.serie],
  ];
  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2, bgcolor: "#fff" }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#243b53", mb: 2 }}>
        Revisa los datos del movimiento
      </Typography>
      <Grid container spacing={2}>
        {fields.map(([label, value]) => (
          <Grid item xs={12} sm={6} key={label}>
            <Typography variant="caption" sx={{ color: "#526579" }}>
              {label}
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, color: "#243b53", overflowWrap: "anywhere" }}
            >
              {value || "Sin información"}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
          p: 1.5,
          bgcolor: "#f3f6fa",
          borderRadius: 1.5,
        }}
      >
        <Box>
          <Typography variant="caption" display="block" sx={{ color: "#526579", mb: 0.5 }}>
            Color de la bicicleta
          </Typography>
          <BikeColor value={formData.color} />
        </Box>
        <Box>
          <Typography variant="caption" sx={{ color: "#526579" }}>
            Gancho seleccionado
          </Typography>
          <Typography variant="h6" sx={{ color: "#193e54" }}>
            #{String(gancho?.id || "").padStart(2, "0")}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}
IngresoReview.propTypes = { formData: PropTypes.object.isRequired, gancho: PropTypes.object };
